import React from 'react';
import Button from '../../setup_viewer/components/extras/button';

function WasmSidebarRevisionButtons(props) {
  const { onClickViewChanges, onClickConfirm } = props;
  return (
    <>
      <Button theme="success" onClick={onClickConfirm}>
        Confirm Revision
      </Button>
      <Button theme="secondary_outline" onClick={onClickViewChanges}>
        View Changes
      </Button>
    </>
  );
}

export default WasmSidebarRevisionButtons;
